import styled from '@emotion/styled';

export const AuditPanelWrapper = styled('div', { label: 'AuditPanelWrapper' })`
    width: calc(100% - 40px);
    height: calc(100% - 80px);
    margin: 60px 20px 20px 20px;
    background-color: white;
    padding: 20px;
    display: flex;
    flex-direction: column;

    .audit-details {
        position: relative;
        z-index: 2;
        flex-shrink: 0;
    }
`;
